import { render, staticRenderFns } from "./HapusDuplikat.vue?vue&type=template&id=84e5e81a&scoped=true&"
import script from "./HapusDuplikat.vue?vue&type=script&lang=js&"
export * from "./HapusDuplikat.vue?vue&type=script&lang=js&"
import style0 from "./HapusDuplikat.vue?vue&type=style&index=0&id=84e5e81a&scoped=true&lang=css&"
import style1 from "./HapusDuplikat.vue?vue&type=style&index=1&id=84e5e81a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84e5e81a",
  null
  
)

export default component.exports